const checkCheckbox = (value) => {
    return value === undefined ? false : true
}

export default checkCheckbox
